module.exports = __webpack_public_path__ + "static/media/panda.06de9929.svg";